(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaAccountController', RcopiaAccountController);

    RcopiaAccountController.$inject = ['GenericEntityDatatableService', 'CoreService', 'RcopiaAccount', '$uibModal',
        '$q', 'ConfirmationService'];

    function RcopiaAccountController(GenericEntityDatatableService, CoreService, RcopiaAccount, $uibModal,
                              $q, ConfirmationService) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Rcopia Accounts',
            newButtonTitle: 'New Account',
            entityClassHumanized: 'Rcopia Accounts',
            entityStateName: 'rcopia-account',
            service: RcopiaAccount,
            serviceMethod: 'findAllByCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'login',
                    title: 'Employee',
                    render: function (entity) {
                        return entity.employee.firstName + " " + entity.employee.lastName;
                    }
                },
                {
                    name: 'username',
                    title: 'Username',
                },
                {
                    name: 'externalId',
                    title: 'ExternalId',
                },
                {
                    name: 'rcopiaAccountType',
                    title: 'Account Type',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Rcopia Account',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/rcopia-account/update/rcopia-account-dialog.html',
                controller: 'RcopiaAccountDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'md',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            id: null,
                            username: null,
                            password: null,
                            signaturePassword: null,
                            externalId: null,
                            rcopiaAccountType: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/rcopia-account/update/rcopia-account-dialog.html',
                controller: 'RcopiaAccountDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['RcopiaAccount', function (RcopiaAccount) {
                        return RcopiaAccount.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('RcopiaAccount').result.then(function () {
                    RcopiaAccount.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();
